import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const EllipseIcon = ({ fillColor }) => createIcon({
    displayName: 'EllipseIcon',
    viewBox: '0 0 8 8',
    path: (_jsx("circle", { cx: "4", cy: "4", r: "4", fill: fillColor })),
});
//# sourceMappingURL=EllipseIcon.js.map